import $ from 'jquery';
import { isValidPhoneNumber } from '../phone-input';
import { GALogin } from '../ga/sign_up';
import eSputnik from '../eSputnik';
import recaptchaEnterprise, { RECAPTCHA_ACTIONS } from "scripts/components/recaptcha/recaptcha";
import { allowedLocales } from "scripts/utils/constants";

let locale = $('html').attr('lang');
if (!(locale in allowedLocales)) {
  locale = allowedLocales.uk;
}
const errorMessages = {
  default: null,
  phone: null,
  code: null,
};
const preloader = (start) => {
  if (start) {
    if (!$('.xmlPreloader').length) {
      $('body').append(
        `<div class="xmlPreloader"><div class="xmlPreloader__content"><span></span><span></span><span></span><span></span></div></div>`
      );
    }
    $('.xmlPreloader').fadeIn();
  } else {
    $('.xmlPreloader').fadeOut();
  }
};

const layout = ({ common, fields }, source) => {
  const template = `
    <div class="modal modal-login" data-target='modal-login'>
      <div class="modal__zoom">
        <div class="modal-content">
          <div class="close-btn js-close"></div>
          <div class="modal-login__content">
            <form class="login-phone">
              <div class="modal-content__title">
                ${common.log_in_title}
              </div>
              <label for="" class="form-label" id="login-modal-label">
                <input type="${fields[0].type}" name="${fields[0].name}" id="modal-login-tel" class="form-label__input" required>
                <span class="form-label__placeholder">${fields[0].title}</span>
                <span class="error-text" data-error-default="${common.error_default}">${fields[0].error_text}</span>
              </label>
              <button class="wb-btn btn-yellow login-phone__next"><span>${common.submit}</span></button>
            </form>
            <form class="login-code">
              <div class="modal-content__title">
                ${common.confirm_title}
              </div>
              <label for="" class="form-label">
                <input type="tel" id="modal-login-code" autocomplete="off" name="${fields[1].name}" class="form-label__input" placeholder="${fields[1].title}">
                <span class="error-text">${fields[1].error_text}</span>
              </label>
              <button class="wb-btn btn-yellow disabled" id="submit-login" data-source="${source}"><span>${common.confirm_submit}</span></button>
              <div class="login-code__counter flex-c-c disabled" id="login-resend">
                <div class="counter-button">
                  ${common.resubmit} <span class="counter" id="login-counter" data-minutes="1"></span>
                </div>
              </div>
              <div class="back flex-c-c" id="login-back">
                <span>${common.back}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>`;

  $('body').append(template);
  $('.modal-login').fadeIn(300);
  $('html').addClass('overflow');
  $('#modal-login-tel').focus();
};

const modalLogin = {
  isResizeListenerAdded: false,
  call: function createTemplate(source) {
    return $.get(`/api/get_form_data?locale=${locale}&action=login`, (response) => {
      // Set error messages
      errorMessages.default = response.common.error_default;
      errorMessages.phone = response.fields[0].error_text;
      errorMessages.code = response.fields[1].error_text;

      layout(response, source);

      const resizeVisualViewportEventHandler = () => {
        const phoneInputField = document.getElementById('modal-login-tel');
        const codeInputField = document.getElementById('modal-login-code');

        setTimeout(() => {
            [phoneInputField, codeInputField].forEach((inputField) => {
              inputField?.scrollIntoView({ block: "center", behavior: "smooth" });
            });
        }, 60)

      };

      if (!this.isResizeListenerAdded) {
        window.visualViewport.addEventListener('resize', resizeVisualViewportEventHandler);
        this.isResizeListenerAdded = true;
      }
      
    }).fail((err) => {
      // eslint-disable-next-line no-console
      console.log(err);
    });
  },
};

const loginQuery = () => {
  let responseNumber = {};
  let timerAgree = true;
  let phoneValue = '';
  let timer;

  const countDown = ($item) => {
    const minutes = $item.data('minutes');
    const countDate = new Date();
    const button = $item.parents('.counter-button');

    countDate.setMinutes(countDate.getMinutes() + minutes);

    const countDateTimestamp = countDate.getTime();

    button.addClass('disabled');
    button.attr('disabled', true);

    const addZero = (num) => {
      const number = parseInt(num, 10);

      return number < 10 ? `0${number}` : number;
    };

    const updateTimer = () => {
      const date = new Date().getTime();
      const distance = countDateTimestamp - date;
      const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const sec = Math.floor((distance % (1000 * 60)) / 1000);
      const concat = `(${addZero(min)}:${addZero(sec)})`;

      $item.html(concat);
      button.addClass('disabled');
      button.attr('disabled', true);
      if (distance <= 0) {
        clearInterval(timer);

        button.removeClass('disabled');
        button.removeAttr('disabled');
        const parent = $item.parents('#login-resend');
        parent.removeClass('disabled');
        timerAgree = true;
        $item.html('');
      }
    };

    clearInterval(timer);

    updateTimer();

    timer = setInterval(updateTimer, 1000);
  };

  const login = (mhetod, token, number, phoneCode, source) => {
    if (mhetod === 'confirm') {
      window.isLoginConfirm = true;
    }
    $.ajax({
      url: `/api/${mhetod}`,
      type: 'POST',
      headers: {
        'Accept-Language': locale,
      },
      contentType: 'application/json',
      data: JSON.stringify({
        data: {
          authToken: token,
          telephoneNumber: number,
          code: phoneCode,
        },
      }),
      dataType: 'json',
      beforeSend: () => {
        preloader(true);
      },
      success: ({ data }) => {
        if (data && data.isUserNew) {
          if (window.fbq) window.fbq('track', 'CompleteRegistration');
          eSputnik.addContacts(number);
        }

        window.isLoginConfirm = false;
        GALogin(mhetod === 'confirm', source, data.user_id);
        // eSputnik
        eSputnik.CustomerData({
          user_phone: String(number),
          user_email: '',
        });

        setTimeout(async () => {
          if (data.showUserForm) {
            const { fetchPersonalDataForm } = await import(/* webpackChunkName: "personal-data-form" */ './personalDataForm')
            fetchPersonalDataForm(locale, preloader);
          } else {
            window.location.reload();
          }
        }, 1000);
      },
      error: () => {
        preloader(false);
        $('.modal-login .login-code .form-label').addClass('error');
      },
    });
  };

  const send = async (phoneNumber) => {
    countDown($('#login-counter'));

    const { token } = await recaptchaEnterprise.executeRecaptcha(RECAPTCHA_ACTIONS.LOGIN)
    $.ajax({
      url: '/api/login',
      type: 'POST',
      contentType: 'application/json',
      headers: {
        'Accept-Language': locale,
      },
      data: JSON.stringify({
        data: {
          telephoneNumber: phoneNumber,
          'g-recaptcha-response': token,
        },
      }),
      dataType: 'json',
      success: (response) => {
        $('.login-code .form-label').removeClass('error');
        $('.modal-login').addClass('active');
        responseNumber = { ...response };
        $('#modal-login-code').focus();
      },
      error: ({ responseJSON: { error = null } = {} }) => {
        $('#login-modal-label').addClass('error');
        $('.login-code .form-label').addClass('error');
        const errorDetail = error?.detail ?? null;
        const errorText = errorDetail ?? errorMessages.default;
        $('#login-modal-label .error-text').text(errorText);
      },
    });
  };

  function submitLogin(event) {
    event.preventDefault();
    const $this = $(this);
    const value = $this.find('.form-label input').val();
    const source = $this.find('#submit-login').attr('data-source');

    if (value.trim() !== '' && value.length === 6 ) {
      if (!responseNumber.data.userExist) {
        login(
          'register',
          responseNumber.data.authToken,
          phoneValue,
          value,
          source
        );
      } else {
        login(
          'confirm',
          responseNumber.data.authToken,
          phoneValue,
          value,
          source
        );
      }
    }
  }

  function sendPhone(event) {
    event.preventDefault();
    const label = $(this).find('.form-label');
    const val = label.find('input[type="tel"]').val();

    if (isValidPhoneNumber(val)) {
      label.removeClass('error');
      phoneValue = val.replace(/[+ ]/g, '');
      send(phoneValue);
    } else {
      $('#login-modal-label .error-text').text(errorMessages.phone);
      label.addClass('error');
    }
  }

  // Input validation
  $(document)
    .on('submit', '.login-phone', sendPhone)
    .on('submit', '.login-code', submitLogin)
    .on(
      'keyup',
      '.modal-login .login-code .form-label__input',
      function showAgreeLogin() {
        const value = $(this).val();
        const button = $('.modal-login .login-code').find('#submit-login');

        $('.modal-login .login-code .form-label').removeClass('error');

        if (value.trim() !== '' && value.length === 6) {
          button.removeClass('disabled').removeAttr('disabled');
        } else {
          button.addClass('disabled').attr('disabled', true);
        }
      }
    )
    .on('click', '#login-back', () => {
      $('.modal-login').removeClass('active');
      // Erase code input
      $('#modal-login-code').val('');
      // Erase error message from phone input
      $('.login-phone .form-label').removeClass('error');
    })
    .on('click', '#login-resend:not(.disabled)', (e) => {
      const { target } = e;
      const closest = $(target).closest('.counter-button');

      if (closest.length && !closest.hasClass('disabled') && timerAgree) {
        countDown($('#login-counter'));
        $('.modal-login #login-resend').addClass('disabled');
        timerAgree = false;

        send(phoneValue);
        $('#modal-login-code').val('');
      }
    });
};

loginQuery();

export default modalLogin;
